import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function TermsAcceptanceCheckbox({ onAcceptanceChange, required = true }) {
	const [accepted, setAccepted] = useState(false);

	// Check localStorage on component mount - only auto-check if user just accepted
	useEffect(() => {
		const termsJustAccepted = localStorage.getItem('termsJustAccepted') === 'true';
		if (termsJustAccepted) {
			// User just came from accepting terms - auto-check and clear the flag
			setAccepted(true);
			if (onAcceptanceChange) {
				onAcceptanceChange(true);
			}
			// Clear the flag so it doesn't auto-check on future page loads
			localStorage.removeItem('termsJustAccepted');
		}
	}, [onAcceptanceChange]);

	const handleChange = (event) => {
		const isChecked = event.target.checked;
		setAccepted(isChecked);
		if (onAcceptanceChange) {
			onAcceptanceChange(isChecked);
		}
	};

	return (
		<div className="flex items-start space-x-3 p-4 border border-gray-200 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-800">
			<input
				type="checkbox"
				id="terms-acceptance"
				checked={accepted}
				onChange={handleChange}
				required={required}
				className="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
			/>
			<label htmlFor="terms-acceptance" className="text-sm text-gray-700 dark:text-gray-300">
				<span className={required ? 'text-red-600' : ''}>
					{required && '*'} I have read and agree to the{' '}
				</span>
				<Link 
					to="/terms" 
					target="_blank" 
					rel="noopener noreferrer"
					className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 underline font-medium"
				>
					Terms and Conditions
				</Link>
				{required && (
					<span className="text-red-600 text-xs block mt-1">
						* Required field
					</span>
				)}
			</label>
		</div>
	);
}

export default TermsAcceptanceCheckbox;